document.addEventListener('click', async function (e) {
    const btnModalEditarTurno = e.target.closest('#btnModalEditarTurno');
    if (!btnModalEditarTurno) return;

    const idTurno = btnModalEditarTurno.getAttribute("data-id");
    const formEditar = document.querySelector("#formEditarTurno");
    const modalEditar = document.querySelector("#ModalEditarTurno");

    if (!formEditar || !idTurno || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar el turno.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/turnos/infoTurno?idTurno=${idTurno}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del turno.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputIdTurno       = formEditar.querySelector('#idTurnoEditar');
        const inputNombreTurno   = formEditar.querySelector('#nombreTurnoEditarDisplay');
        const inputHoraInicio    = formEditar.querySelector('[name="horaInicio"]');
        const inputHoraFin       = formEditar.querySelector('[name="horaFin"]');
        const selectArea         = formEditar.querySelector('[name="areaId"]');
        const divShitch          = formEditar.querySelector('#divShitchTurno');

        if (inputIdTurno)     inputIdTurno.value     = data.idTurno     || "";
        if (inputNombreTurno) inputNombreTurno.value = data.nombreTurno || "";
        if (inputHoraInicio)  inputHoraInicio.value  = data.horaInicio  || "";
        if (inputHoraFin)     inputHoraFin.value     = data.horaFin     || "";
        if (selectArea) {
            selectArea.value = data.areaId || "";
        }

        const checked     = Number(data.estadoTurno) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estadoTurno) === 1 ? 'ACTIVO' : 'INACTIVO';

        divShitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estadoTurno"
                    value="${data.estadoTurno}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información del turno:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del turno.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarTurno') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarTurno');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar el turno.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/turnos/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Turno editado correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
